import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as SearchIc } from "../../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../../assets/svg/add_icon.svg";
import { ReactComponent as EditIc } from "../../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../../assets/svg/delete_ic.svg";
import { ReactComponent as RarIc } from "../../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../../assets/svg/lar_ic.svg";
import { ReactComponent as DownArrowIc } from "../../../assets/svg/down_arrow_ics.svg";
import ReactPaginate from "react-paginate";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";

import DeleteModal from "../../common/deleteModel";
import { usePermission } from "../../common/checkPermission";
import {
  bulkDeleteVendorStageApi,
  deleteVendorStageListApi,
  getVendorStageByIdApi,
  getVendorStageListApi,
  submitVendorStageApi,
  updateVendorStageListApi,
} from "./vendorStageApi";
import CommonMasterModal from "../common/commonMasterCreateModel";

export const VendorStageList = () => {
  const { checkPermission } = usePermission();
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [createModal, setCreateModal] = useState(false);
  const [search, setSearch] = useState("");
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [projectStageList, setProjectStageList] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const normalizeId = (id) =>
    id === null || id === undefined ? id : String(id);

  const toggleSelectAll = () => {
    if (!projectStageList || projectStageList.length === 0) {
      setSelectedIds([]);
      return;
    }
    const allIds = projectStageList.map((i) => normalizeId(i.id ?? i._id));
    if (
      selectedIds.length === allIds.length &&
      allIds.every((id) => selectedIds.includes(id))
    ) {
      setSelectedIds([]);
    } else {
      setSelectedIds(allIds);
    }
  };
  const toggleSelectOne = (id) => {
    const nid = normalizeId(id);
    setSelectedIds((prev) => {
      if (!prev) return [nid];
      if (prev.includes(nid)) return prev.filter((x) => x !== nid);
      return [...prev, nid];
    });
  };
  //   api
  const getProjectStageList = async () => {
    try {
      const params = {
        limit: itemsPerPage,
        skip: itemOffset * itemsPerPage,
        search,
        sort_field: "Created",
        sort_dir: "desc",
      };

      const response = await getVendorStageListApi(params);
      const {
        success,
        total_rec = 0,
        total_pgs = 0,
        vendor_stage = [],
      } = response?.data || {};

      if (!success) return;

      setTotalCount(total_rec);
      setPageCount(total_pgs);
      setProjectStageList(vendor_stage);
    } catch (error) {
      console.error("Failed to fetch project stages:", error);
    }
  };

  const handleEdit = async (id) => {
    try {
      if (!id) return;

      setIsLoading(true);

      const response = await getVendorStageByIdApi(id);
      const data = response?.data?.vendor_stage ?? {};

      if (!data) {
        return;
      }

      setCode(data.code || "");
      setName(data.name || "");
      setEditingId(id);
      setErrorMsg({});
      setCreateModal(true);
    } catch (error) {
      console.error("Failed to fetch project stage:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [errorMsg, setErrorMsg] = useState({ code: "", name: "" });

  const resetForm = () => {
    setCreateModal(false);
    setEditingId(null);
    setCode("");
    setName("");
    setErrorMsg({});
  };

  const showSnackbarFunc = (message, status) => {
    setSnackbarMessage(message);
    setSnackbarStatus(status);
    handleSnackbarShow();
  };

  const resetDeleteState = () => {
    setDeleteId(null);
    setSelectedIds([]);
    setIsBulkDelete(false);
    setIsOpenDelete(false);
  };
  const [isSaving, setIsSaving] = useState(false);
  const handleSave = async () => {
    if (isSaving) return;

    setIsSaving(true);
    try {
      setErrorMsg({});

      const payload = {
        code: code,
        name: name,
      };

      const apiCall = editingId
        ? updateVendorStageListApi(editingId, payload)
        : submitVendorStageApi(payload);

      const response = await apiCall;
      const { success, message, error } = response?.data || {};

      if (!success) {
        setErrorMsg(error || {});
        showSnackbarFunc(message ?? "", false);
        return;
      }

      showSnackbarFunc(message ?? "", true);
      resetForm();
      getProjectStageList();
    } catch (err) {
      console.error("Save failed:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const deleteProjectStage = async () => {
    try {
      setIsLoading(true);

      if (isBulkDelete) {
        if (!selectedIds?.length) {
          return;
        }
        const response = await bulkDeleteVendorStageApi(selectedIds);
        const { success, message } = response?.data || {};

        if (!success) {
          showSnackbarFunc(message ?? "", false);
          return;
        }

        showSnackbarFunc(message ?? "", true);
        resetDeleteState();
        getProjectStageList();
        return;
      }

      if (!deleteId) return;

      const response = await deleteVendorStageListApi(deleteId);
      const { success, message } = response?.data || {};

      if (!success) {
        showSnackbarFunc(message ?? "", false);
        return;
      }

      showSnackbarFunc(message ?? "", true);
      resetDeleteState();
      getProjectStageList();
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProjectStageList();
  }, [itemsPerPage, itemOffset, search]);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  return (
    <div>
      <DeleteModal
        isOpen={isOpenDelete}
        title={
          isBulkDelete ? `selected (${selectedIds.length}) stages` : "stage"
        }
        onClose={() => {
          setIsOpenDelete(false);
          setDeleteId(null);
          setIsBulkDelete(false);
        }}
        onDelete={deleteProjectStage}
      />
      <div
        className="bg-white p-3"
        style={{
          borderBottomRightRadius: "16px",
          borderBottomLeftRadius: "16px",
        }}
      >
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
          <p className="m-0 textGrey fs-13 fw-500">
            Total counts : {totalCount ?? 0}
          </p>
          <div className="d-flex gap-3 flex-wrap">
            {/* Search */}
            <div className="search-wrapper border bg-transparent d-flex align-items-center gap-2 px-3 py-2">
              <SearchIc />
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor bg-transparent"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* Add New*/}
            {selectedIds.length === 0 && (
              <>
                {" "}
                {checkPermission("Vendor Stage", "create_permission") && (
                  <div
                    className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                    onClick={() => setCreateModal(true)}
                    style={{ height: "40px" }}
                  >
                    <AddIc width={14} height={14} />
                    <div className="fs-14 fw-700 textWhitecolor">New Stage</div>
                  </div>
                )}
              </>
            )}

            {/* Bulk Delete button */}
            {selectedIds.length > 0 && (
              <>
                {checkPermission("Vendor Stage", "delete_permission") && (
                  <div
                    className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                    style={{ height: "40px" }}
                    onClick={() => {
                      setIsBulkDelete(true);
                      setIsOpenDelete(true);
                    }}
                  >
                    <DeleteIc
                      style={{
                        filter:
                          "invert(1) sepia(1) saturate(5) hue-rotate(180deg) brightness(2)",
                      }}
                    />
                    <div className="fs-14 fw-700 textWhitecolor">Delete</div>
                  </div>
                )}
              </>
            )}

            {/* Import  */}
            {/* <div
              className="my-import d-flex align-items-center justify-content-center gap-2"
              style={{ height: "40px" }}
            >
              <ImportIc />
              <div className="fs-14 fw-700 textPurple">Import</div>
            </div> */}
          </div>
        </div>
        <div className="bg-white rounded-4 mt-3 w-100 ">
          <div
            style={{
              display: "flex",
              flex: "10",
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingTop: "16px",
              height: "40px",
              backgroundColor: "#F2F2F2",
            }}
            className="head3 w-100 justify-content-center align-items-center"
          >
            {checkPermission("Vendor Stage", "delete_permission") && (
              <input
                type="checkbox"
                checked={
                  projectStageList.length > 0 &&
                  selectedIds.length === projectStageList.length
                }
                onChange={toggleSelectAll}
                style={{ marginRight: "8px", marginBottom: "14px" }}
              />
            )}
            <p
              style={{ width: "127px", flex: "1.5" }}
              className="fs-13 fw-700 textcolor"
            >
              Code
            </p>
            <p
              style={{ width: "160px", flex: "1.5" }}
              className="fs-13 fw-700 textcolor"
            >
              Name
            </p>
          </div>
          <div>
            {(projectStageList ?? []).map((item, index) => (
              <div
                style={{
                  display: "flex",
                  flex: "10",
                  paddingLeft: "16px",
                  paddingRight: "16px",

                  backgroundColor:
                    hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                  borderBottom: "1px solid #D4DDE7",
                  cursor: "pointer",
                  height: "44px",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className="head3 w-100 justify-content-center align-items-center"
              >
                {checkPermission("Vendor Stage", "delete_permission") && (
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(
                      normalizeId(item.id ?? item._id),
                    )}
                    onChange={(e) => {
                      e.stopPropagation();
                      toggleSelectOne(item.id ?? item._id);
                    }}
                    style={{
                      marginRight: "8px",
                      marginBottom: "0px",
                    }}
                  />
                )}
                <p
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1.5",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    marginTop: "16px",
                  }}
                  title={item.code}
                >
                  {item.code ?? "---"}
                </p>
                <p
                  className="fs-13 fw-500 textcolor"
                  style={{
                    flex: "1.5",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    marginTop: "16px",
                  }}
                  title={item.name}
                >
                  {item.name ?? "---"}
                </p>
                {hoveredIndex === index && (
                  <div
                    style={{
                      position: "absolute",
                      // top: "50%",
                      right: "35px",
                      // transform: "translate(-50%, -50%)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      {checkPermission("Vendor Stage", "edit_permission") && (
                        <div
                          onClick={async (e) => {
                            e.stopPropagation();
                            handleEdit(item.id);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                            borderRadius: "100px",
                            background: "#FFFFFF",
                            cursor: "pointer",
                            border: "0.8px solid #E5E5E5",
                          }}
                        >
                          <EditIc />
                        </div>
                      )}
                      <span style={{ marginLeft: "16px" }}></span>
                      {checkPermission("Vendor Stage", "delete_permission") && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteId(item.id);
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "28px",
                            height: "28px",
                            borderRadius: "100px",
                            background: "#FFFFFF",
                            cursor: "pointer",
                            border: "0.8px solid #E5E5E5",
                          }}
                        >
                          <DeleteIc />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className=" d-flex justify-content-between align-items-center flex-wrap gap-3 me-3 ms-3">
        <Dropdown>
          <span className="pagination-color fs-13 fw-500 ">
            Records per page: &nbsp;
          </span>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
          >
            <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
              {itemsPerPage} <DownArrowIc />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="my-2"
            style={{ minWidth: "unset", width: "40%" }}
          >
            {[10, 25, 50, 75, 100].map((size) => (
              <Dropdown.Item
                key={size}
                onClick={() => {
                  setItemsPerPage(size);
                }}
                active={itemsPerPage === size}
                className="text-center"
              >
                {size}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <div className="d-flex align-items-center gap-2">
          <ReactPaginate
            previousLabel={
              <div
                className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                }}
              >
                <LarIc />
              </div>
            }
            nextLabel={
              <div
                className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                }}
              >
                <RarIc />
              </div>
            }
            breakLabel={"..."}
            pageCount={pageCount + 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </div>
      </div>{" "}
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <CommonMasterModal
        show={createModal}
        title={editingId ? "Update Vendor Stage" : "New Vendor Stage"}
        onClose={() => {
          setCreateModal(false);
          setErrorMsg({});
          setCode("");
          setName("");
          setEditingId(null);
        }}
        isSaving={isSaving}
        onSave={handleSave}
      >
        <form>
          <div className="mb-3">
            <label className="form-label">
              Code <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            {errorMsg.grade_code && (
              <span className="text-danger fs-12">{errorMsg.grade_code}</span>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">
              Stage Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {errorMsg.grade_name && (
              <span className="text-danger fs-12">{errorMsg.grade_name}</span>
            )}
          </div>
        </form>
      </CommonMasterModal>
    </div>
  );
};
